import { Setting } from '@favid-inc/api';
import React from 'react';

export const SettingsContext = React.createContext<Setting[]>([]);
